module.exports = __webpack_public_path__ + "media/newstyle/images/icon-book-orange-47c6a932e653d2af831336ff5cdef35b.svg";